import { Component, OnInit } from '@angular/core';
import { StepService } from 'src/app/services/step.service';
import { CommonService } from 'src/app/services/common.service';
import { ResponsiveLayoutService } from 'src/app/services/responsive-layout.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  readonly BUSINESS_PANELS: { productLabel: string; route: string; defaultSelected: boolean }[] = [
    { productLabel: 'hormigón', route: '/mapa',           defaultSelected: true  },
    { productLabel: 'cemento',  route: '/cemento/mapa',  defaultSelected: false },
  ];

  constructor(
    private readonly stepService: StepService,
    private readonly commonService: CommonService,
    public responsiveService: ResponsiveLayoutService,
    public authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.commonService.clearCheckoutDraft();
    this.stepService.changeStep(0);
  }
}
